import { Image as ShopifyImage } from '@commerce/types/common'
import config from '@config/seo_meta.json'
import Image from 'next/image'
import { FC } from 'react'

interface props {
  img?: ShopifyImage
}

const ProductImage: FC<props> = ({ img }) => {
  return (
    <div className="relative aspect-square w-full md:aspect-productImage">
      {img && img?.url && (
        <Image
          src={img.url}
          alt={img.altText || config.openGraph.images[0].alt}
          fill
          style={{ objectFit: 'cover' }}
          placeholder="blur"
          blurDataURL={img.url}
        />
      )}
      {!img ||
        (!img.url && (
          <div className="aspect-square w-full bg-white md:aspect-productImage"></div>
        ))}
    </div>
  )
}

export default ProductImage
